import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ParamInput extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
  };

  changeProperty = event => {
    this.props.onChange({ [this.props.name]: event.target.value });
  };

  render() {
    const {
      name,
      value,
      isLoading,
    } = this.props;

    return (
      <input
        className="input-custom-param"
        onChange={this.changeProperty}
        name={name}
        value={value}
        disabled={isLoading}
      />
    );
  }
}

